<template>
  <div id="site-header">
    <div class="landing-width-container">
      <template v-if="!showPageNameInHeader">
        <router-link :to="{ name: 'Index' }" class="logo"><img :src="require('@/assets/images/logo-ru.svg')" /></router-link>
        <div class="phone-cont">
          <phone />
          <div class="label">Звонок бесплатный</div>
        </div>
      </template>
      <template v-else>
        <div class="back-button" @click="processClickBack"><svg-inline :src="require('@/assets/icons/arrow-up.svg')" /></div>
        <div class="page-title">
          <img class="icon" :src="currentFirstLevelCategory.acf.icon" v-if="isMenuCategoryPage" />
          <span>{{ pageTitle }}</span>
        </div>
      </template>
      <div class="hamburger hamburger--spin" :class="{ 'is-active': smartphoneMenuOpened }" @click="processHamburgerClick">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Phone from '/src/components/Phone'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SmartphoneSiteHeader',
    components: {
      Phone
    },
    props: {
      smartphoneMenuOpened: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        cart: 'cart/cart',
        totalSum: 'cart/totalSum',
        totalItems: 'cart/totalItems',
        currentFirstLevelCategory: 'menu/currentFirstLevelCategory',
        menuLoaded: 'menu/menuLoaded'
      }),
      isMenuCategoryPage () {
        return this.$route.name === 'MenuCategory'
      },
      showPageNameInHeader () {
        if (this.isMenuCategoryPage) {
          return this.menuLoaded
        }
        return this.$route.name !== 'Index'
      },
      pageTitle () {
        if (this.isMenuCategoryPage) {
          return this.currentFirstLevelCategory.title.rendered
        }
        return this.$route.meta.headerTitle
      }
    },
    methods: {
      processHamburgerClick () {
        this.$emit('toggleSmartphoneMenu')
      },
      processClickBack () {
        if (this.smartphoneMenuOpened) {
          this.$emit('toggleSmartphoneMenu')
        }
        this.$router.go(-1)
        // this.$router.push({ name: 'Index' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SmartphoneSiteHeader.vue